import { useEffect, useState } from "react";
import { doc, setDoc, onSnapshot } from "firebase/firestore";
import { auth, db } from "../firebaseConfig";
import { toast } from "react-toastify";
import { onAuthStateChanged } from "firebase/auth";

function ToastMessageDisplay() {
  const [status, setStatus] = useState({ message: "" });
  const [user, setUser] = useState(null);

  //This useEffect is needed because when the page is refreshed the user is not re-authenticated right away 
  useEffect(() => {
    const unsubscribeAuth = onAuthStateChanged(auth, async (firebaseUser) => {
      if (firebaseUser) {
        console.log("Inside onAuthStateChanged");

        if (!user) {
          console.log("Clearing messages for user: " + firebaseUser.uid);

          try {
            const statusRef = doc(db, "appToastMessages", firebaseUser.uid);
            await setDoc(statusRef, { message: "" }); // Ensure Firestore clears message BEFORE setting user
            console.log("Messages cleared");
          } catch (error) {
            console.error("Error clearing messages:", error);
          }
        }

        setUser(firebaseUser); // Set user AFTER Firestore update is complete
      }
    });

    return () => unsubscribeAuth();
  }, []);

  useEffect(() => {

   // const user = auth.currentUser;
    if (!user) 
    {
      console.log("USER IS NOT AUTHENICATED");
      return;
    } else 
    {
      console.log("USER IS AUTHENICATED:"+user.uid);
    }

    const statusRef = doc(db, "appToastMessages", user.uid);
    const unsubscribe = onSnapshot(statusRef, (doc) => {

    try 
    {
        if (doc.exists()) {
            const data = doc.data();
            setStatus(data);

            if (data.message) {
            toast.info(data.message, { position: "bottom-right" });
            }
        }
    } catch(error)
    {
        console.log("Error on BatchStatusDisplay:"+error);
        console.log("Error on BatchStatusDisplay - stacktrace:"+error.stack);        
    }

    });


    return () => unsubscribe(); // Cleanup listener
  }, [user]);

  return <div>{status.loading && <p>Batch Progress: {status.progress}%</p>}</div>;
}

export default ToastMessageDisplay;
